import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabsRootFn = /* @__PURE__ */ createRecipe('tabs', {}, [])

const tabsRootVariantMap = {}

const tabsRootVariantKeys = Object.keys(tabsRootVariantMap)

export const tabsRoot = /* @__PURE__ */ Object.assign(memo(tabsRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'tabsRoot',
  __getCompoundVariantCss__: tabsRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tabsRootVariantKeys,
  variantMap: tabsRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabsRootVariantKeys)
  },
  getVariantProps: tabsRootFn.getVariantProps,
})